module.exports = __webpack_public_path__ + "static/media/delete-icon.34c8bb3c.svg";